import Api from "../../Api";
import { message } from "antd";
import { modifyError } from "../../Validation/ModifyErrros";

const extractUploadError = (data) => {
  if (!data) return "Unknown error occurred.";
  return (
    data?.e?.response?.message ||
    data?.e?.message ||
    data?.message ||
    "Unknown error occurred."
  );
};

export const uploadData = async (file, imageType, oldFileName = null) => {
    try {
      const formData = new FormData();
      formData.append('file', file)
      formData.append('imageType', imageType?.type);
      formData.append('imageSubType', imageType?.subType)
      if (oldFileName) formData.append("oldFileName", oldFileName);
      let res = await Api.post("/upload", formData ,{
        headers: {
            'Content-Type': 'multipart/form-data',
          },
      });
    
      const data = res?.data || [];
      if (data?.status === false) {
        const errMsg = extractUploadError(data);
        message.error(errMsg);
        return { error: errMsg, e: data?.e };
      }
      return data;
    } catch (e) {
      let error = modifyError(e);
      message.error(error.message);
      return { error: error.message };
    }
};
